var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoatComputerMatelot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 323.45,
    height: 188.73,
    viewBox: "0 0 323.45 188.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BOAT_ORDINATEUR",
    "data-name": "BOAT ORDINATEUR",
    transform: "translate(-96.458 -44.395)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "FOND_TRANSPARENT",
    "data-name": "FOND TRANSPARENT",
    width: 323.45,
    height: 188.73,
    transform: "translate(96.458 44.396)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3500",
    "data-name": "Group 3500",
    transform: "translate(313.127 185.245) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8733",
    "data-name": "Path 8733",
    d: "M8.523,0c.048,29.75.13,80.519.173,107.318C-8.592,57.953,4.564,11.794,8.523,0Z",
    transform: "translate(47.92 12.083)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(15 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8736",
    "data-name": "Path 8736",
    d: "M3.536,10.556c.049,30.371.133,83.3.177,110.059,0,.915,0,1.805,0,2.657.012,7.831.021,12.917.022,13.724a7.262,7.262,0,0,1-.208,1.778C2.785,141.761.228,141.817.221,137c0-.977-.023-13.807-.023-13.807L.191,119.4S.067,41.833.019,12.083c.634-1.886,1.034-2.9,1.034-2.9L.015,9.165C.009,5.767,0,2.687,0,.019Q1.762.011,3.519,0C3.524,3.072,3.529,6.618,3.536,10.556Z",
    transform: "translate(56.424 0)",
    fill: "#9f721e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501",
    transform: "translate(4.056 8.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8762",
    "data-name": "Path 8762",
    d: "M108.476.267S79.811,25.751,62.566,57.217c-1.483,2.705-2.882,5.453-4.171,8.236-9.582,20.685-13.064,43.128,0,62.239.345.506.682,1.013,1.051,1.515,0,0-.372-.109-1.051-.34-6.426-2.189-40.569-15.469-51.5-53.7C-5.193,32.9,1.64,3.477,4.792,1.337,6.381.259,32.683,0,58.4,0q2.089,0,4.171,0C86.371.032,108.476.267,108.476.267Z",
    transform: "translate(0 0)",
    fill: "#d3bf92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8763",
    "data-name": "Path 8763",
    d: "M21.8,129.194S-1.605,116.975.088,70.855C1.115,42.881,17.624,16.46,30.456,0,52.04.054,70.828.254,70.828.254S42.163,25.738,24.918,57.2c-1.483,2.705-2.882,5.453-4.171,8.236-9.582,20.686-13.064,43.128,0,62.239C21.093,128.185,21.429,128.692,21.8,129.194Z",
    transform: "translate(37.648 0.013)",
    fill: "#c1ac7c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2069",
    "data-name": "Group 2069",
    transform: "translate(107.562 172.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3010",
    "data-name": "Path 3010",
    d: "M103.639,82.9c-4.311-.466-7.95,2.109-7.04,5,2.986,9.517,10.229,27.129,23.435,30.032,18.267,4.015,10.962,14.822,27.392,14.822s139.69,1.852,180.324,1.852,68.017-51.563,69.845-57.43-19.177,4.015-136.042,8.34C172.539,88.807,122.454,84.935,103.639,82.9Z",
    transform: "translate(-96.458 -75.363)",
    fill: "#ad802c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8760",
    "data-name": "Path 8760",
    d: "M327.749,134.6c40.625,0,68.017-51.563,69.845-57.43,1.254-4.025-8.237-.638-52.234,3.3C371.017,100.561,287.116,134.6,327.749,134.6Z",
    transform: "translate(-96.458 -75.363)",
    fill: "#c39642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3011",
    "data-name": "Path 3011",
    d: "M97.411,90.366a7.541,7.541,0,0,1,6.228-1.906c18.815,2.031,68.9,5.9,157.913,2.611,95.8-3.543,127.156-10.813,134.355-10.09a31.067,31.067,0,0,0,1.687-3.806c1.828-5.867-19.177,4.015-136.042,8.34-89.014,3.292-139.1-.58-157.913-2.617-4.311-.466-7.95,2.109-7.04,5C96.837,88.669,97.12,89.506,97.411,90.366Z",
    transform: "translate(-96.458 -75.363)",
    fill: "#7e5913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3012",
    "data-name": "Path 3012",
    d: "M302.871,100.858c16.35,0,30.546-8.352,41.808-18.711-64.854,5.568-154.8,9.9-245.045,3.357,12.552,4.654,8.038,13.5,22.914,13.5C138.986,99.006,262.238,100.858,302.871,100.858Z",
    transform: "translate(-71.58 -41.616)",
    fill: "#9f721e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3013",
    "data-name": "Path 3013",
    d: "M105.535,88.826c86.567,5.819,172.294,1.858,235.4-3.441,1.281-1.057,2.535-2.127,3.745-3.238-64.854,5.568-154.8,9.9-245.045,3.357A19.881,19.881,0,0,1,105.535,88.826Z",
    transform: "translate(-71.58 -41.616)",
    fill: "#7e5913"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8732",
    "data-name": "Path 8732",
    d: "M109.068,88.838C211.962,94.657,310.09,90.6,385.1,85.3c.954-1.036,1.351-1.752,2.559-3.155-77.087,5.568-173.709,9.77-280.982,3.228A31.665,31.665,0,0,0,109.068,88.838Z",
    transform: "translate(-100.118 -57.616)",
    fill: "#7e5913"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatComputerMatelot);
export default __webpack_public_path__ + "static/media/boat-computer-matelot.15726b83.svg";
export { ForwardRef as ReactComponent };